import { Station } from "../domain/types";
import { ApiPortEntry } from "../domain/visuals/SearchControl";
import { apiGet } from "./api";


export async function fetchStations(): Promise<Station[] | null> {
	return apiGet<Station[]>("config/stations");
}
export async function getStatus(): Promise<any> {
	return apiGet<any[]>("config/status");
}
export async function getPorts(): Promise<Array<ApiPortEntry> | null> {
	return apiGet<any[]>("config/ports");
}